Ext.define('SA.view.RangeSlider', {
    alias: 'widget.range-slider',
    extend: 'SA.view.SimpleContainer',

    baseCls: 'sa-range-slider',

    initComponent() {
        var limits = this.limits,
            formatLabel = this.formatLabel = (this.formatLabel || String);

        this.items = [{
            xtype: 'simple-container',
            cls: 'sa-range-slider-wrap-outer',

            items: [{
                xtype: 'simple-container',
                cls: 'sa-range-slider-wrap-middle',

                items: [{
                    xtype: 'simple-container',
                    cls: 'sa-range-slider-wrap-inner',

                    items: [{
                        xtype: 'multislider',
                        animate: false,
                        increment: this.stepIncrement,
                        itemId: 'slider',
                        maxValue: limits[1],
                        minValue: limits[0],
                        tipText: formatTip,
                        values: limits,
                        width: 215
                    }]
                }]
            }]
        }];

        this.callParent();

        this.slider = this.down('#slider');

        this.slider.on({
            scope: this,

            afterrender: this.afterSliderRender,
            change: this.refreshSelectedRange,
            dragend: this.onSliderInteractionDone,
            trackclick: this.onSliderInteractionDone
        });

        function formatTip(thumb) {
            return formatLabel(thumb.value);
        }
    },

    afterSliderRender(slider) {
        this.sliderInnerEl = slider.innerEl.dom;

        this.buildTicks();
        this.buildSelectedRange();
        this.buildLabels();
    },

    buildLabels() {
        var increment = this.labelIncrement,
            formatLabel = this.formatLabel,
            target = this.sliderInnerEl;

        this.eachValueAndLeftPositionByIncrement(increment, function(value, left) {
            var containerEl = document.createElement('div'),
                labelEl = document.createElement('div');

            Ext.fly(containerEl).addCls('sa-range-slider-label-container');
            Ext.fly(containerEl).setStyle('left', left + '%');

            Ext.fly(labelEl).addCls('sa-range-slider-label');
            Ext.fly(labelEl).update(formatLabel(value));

            containerEl.appendChild(labelEl);
            target.appendChild(containerEl);
        });
    },

    buildSelectedRange() {
        var el = this.selectedRangeEl = document.createElement('div');

        Ext.fly(el).addCls('sa-range-slider-selected-range');

        this.sliderInnerEl.appendChild(el);

        this.refreshSelectedRange();
    },

    buildTicks() {
        var increment = this.tickIncrement,
            target = this.sliderInnerEl;

        this.eachValueAndLeftPositionByIncrement(increment, function(value, left) {
            var el = document.createElement('div');

            Ext.fly(el).addCls('sa-range-slider-tick');
            Ext.fly(el).setStyle('left', left + '%');

            target.appendChild(el);
        });
    },

    computeLeftPositionPercentage(value) {
        return this.slider.calculateThumbPosition(value);
    },

    eachValueAndLeftPositionByIncrement(increment, callback) {
        var limits = this.limits,
            lowerLimit = limits[0],
            upperLimit = limits[1];

        for (let value = lowerLimit; value <= upperLimit; value += increment) {
            let left = this.computeLeftPositionPercentage(value);

            callback(value, left);
        }
    },

    getMinMax() {
        return this.slider.getValues();
    },

    onSliderInteractionDone() {
        this.fireEvent('interactiondone', this.getMinMax());
    },

    refreshSelectedRange() {
        var el = this.selectedRangeEl,
            minMax = this.getMinMax(),
            left = this.computeLeftPositionPercentage(minMax[0]),
            right = this.computeLeftPositionPercentage(minMax[1]),
            width = right - left;

        Ext.fly(el).setStyle({
            left: left + '%',
            width: width + '%'
        });
    },

    setMinMax(minMax) {
        var min = minMax[0],
            max = minMax[1],
            hasMin = min != null,
            hasMax = max != null,
            outOfOrder = hasMin && hasMax && min > max,
            slider, limits, lowerLimit, upperLimit, constrain;

        if (!outOfOrder) {
            slider = this.slider;
            limits = this.limits;
            lowerLimit = limits[0];
            upperLimit = limits[1];
            constrain = Ext.Number.constrain;

            min = hasMin ? constrain(min, lowerLimit, upperLimit) : lowerLimit;
            max = hasMax ? constrain(max, lowerLimit, upperLimit) : upperLimit;

            slider.setValue(0, min, false);
            slider.setValue(1, max, false);

            slider.promoteThumb(slider.thumbs[min === upperLimit ? 0 : 1]);
        }
    }
});
